module.exports = __webpack_public_path__ + "static/media/h4p_top_03.ae1494df.gif";